<template lang="pug">
  .blog-entry-content.has-text-left
    h2.subtitle.is-uppercase(@click.prevent="$router.go(-1)", style="cursor:pointer;")
      fa-icon(icon="angle-left", style="margin-right:5px;")
      | Back
    h1.title.is-uppercase {{details.title}}
    img(:src="details.feature")
    .blog-entry-bottom
      .blog-entry-article.has-text-weight-normal.content
        div(v-html="details.content")
        hr
        .details-bar
          div(style="flex: 1")
            span Share:
            social-sharing(:title='details.metaTitle', :description='details.metaDescription', :quote='details.synopsis', hashtags='isp,cybersmart', twitter-user='cybersmart', inline-template='')
              .social-buttons
                network(network='email')
                  fa-icon(icon="envelope", size="2x", style="margin-right:5px;")
                network(network='facebook')
                  fa-icon(:icon="['fab', 'facebook-square']", size="2x", style="margin-right:5px;")
                network(network='line')
                  fa-icon(:icon="['fab', 'line']", size="2x", style="margin-right:5px;")
                network(network='linkedin')
                  fa-icon(:icon="['fab', 'linkedin']", size="2x", style="margin-right:5px;")
                network(network='reddit')
                  fa-icon(:icon="['fab', 'reddit']", size="2x", style="margin-right:5px;")
                network(network='sms')
                  fa-icon(icon="sms", size="2x", style="margin-right:5px;")
                network(network='telegram')
                  fa-icon(:icon="['fab', 'telegram']", size="2x", style="margin-right:5px;")
                network(network='twitter')
                  fa-icon(:icon="['fab', 'twitter']", size="2x", style="margin-right:5px;")
                network(network='whatsapp')
                  fa-icon(:icon="['fab', 'whatsapp']", size="2x", style="margin-right:5px;")
          span.time
            fa-icon(icon="clock")
            span(style="margin-left:5px;") {{details.revealDate}}
      .blog-entry-recommended
        h1.title.is-uppercase Related news
        BlogArticle(v-for="(v, k) of posts", :key="k", :v="v")
</template>

<script>
  import _ from 'lodash'
  import moment from 'moment'
  import marked from 'marked'

  import BlogArticle from '@/components/BlogArticle.vue'

  export default {
    props: ['id'],
    components: {
      BlogArticle
    },
    data() {
      return {
        details: '',
        posts: []
      }
    },
    async mounted() {
      const details = (await this.$http.get(`${process.env.VUE_APP_BACKEND_URL}blogs/${this.id}`)).data

      this.details = {
        title: details.title,
        category_id: details.category.id,
        revealDate: moment(details['Reveal Date'])
          .format('MMM D, YYYY'),
        content: marked(details.content),
        feature: `${process.env.VUE_APP_BACKEND_URL}${details.feature.url}`,
        metaTitle: details['meta title'],
        metaDescription: details['meta description'],
        synopsis: details.synopsis
      }

      const response = await this.$http.get(`${process.env.VUE_APP_BACKEND_URL}blogs/by-category?category.id=${details.category.id}&id_ne=${details.id}`)

      _.each(response.data, item => {
        this.posts.push({
          id: item.id,
          revealDate: moment(item['Reveal Date'])
            .format('MMM D, YYYY'),
          category: item.category?.Name,
          categoryId: item.category?.id,
          // content: marked(value.content),
          feature: `${process.env.VUE_APP_BACKEND_URL}${item.feature.url}`,
          synopsis: item.synopsis,
          title: item.title
        })
      })
    }
  }
</script>

<style lang="scss">
  @import "~bulma/sass/utilities/mixins";

  .blog-entry-content {
    margin: 2rem 3rem;
    .blog-entry-bottom {
      display: flex;
      padding-top: 2rem;

      @include until($desktop) {
        flex-direction: column;
      }
      .blog-entry-article {
        flex: 1;

        @include from($desktop) {
          padding-right: 6rem;
        }

        .details-bar {
          display: flex;
          .social-buttons > * {
            cursor: pointer;
          }
        }
      }
      .blog-entry-recommended {
        min-width: 300px;
        @include from($desktop) {
          max-width: 25vw;
        }

        > * {
          max-width: calc(100vw - 6rem);
        }
      }
    }
  }
</style>
